export default __webpack_public_path__ + "static/media/login-button.ae0c7110.svg";